import { useEffect, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";

const LINKS = [
  { to: "/", label: "Home" },
  { to: "/about", label: "About" },
  { to: "/divisions", label: "Divisions" },
  { to: "/portfolio", label: "Portfolio" },
  { to: "/partner", label: "Partner" },
  { to: "/contact", label: "Contact" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => { setOpen(false); }, [location.pathname]);

  return (
    <header
      data-testid="site-navbar"
      className={`fixed top-0 left-0 right-0 z-50 transition-colors duration-300 ${
        scrolled || open
          ? "bg-white/85 backdrop-blur-xl border-b border-stone"
          : "bg-white/60 backdrop-blur-md border-b border-transparent"
      }`}
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 h-16 md:h-20 flex items-center justify-between">
        <Link to="/" data-testid="nav-logo" className="flex items-center gap-2">
          <span className="font-extrabold tracking-tight text-navy text-[15px] md:text-[17px]">
            STONE SHIRE <span className="text-forest">GROUP</span>
          </span>
        </Link>
        <nav className="hidden md:flex items-center gap-8">
          {LINKS.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              data-testid={`nav-link-${l.label.toLowerCase()}`}
              className={({ isActive }) =>
                `text-sm font-medium ${isActive ? "text-forest" : "text-navy hover:text-forest"} transition-colors`
              }
              end={l.to === "/"}
            >
              {l.label}
            </NavLink>
          ))}
          <Link
            to="/partner"
            data-testid="nav-cta-partner"
            className="btn-primary rounded-full px-5 py-2 text-sm font-semibold"
          >
            Partner with us
          </Link>
        </nav>
        <button
          data-testid="nav-mobile-toggle"
          aria-label="Toggle menu"
          className="md:hidden p-2 text-navy"
          onClick={() => setOpen((v) => !v)}
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>
      {open && (
        <div className="md:hidden bg-white border-t border-stone" data-testid="mobile-menu">
          <nav className="px-6 py-4 flex flex-col gap-4">
            {LINKS.map((l) => (
              <NavLink
                key={l.to}
                to={l.to}
                data-testid={`mobile-nav-link-${l.label.toLowerCase()}`}
                className={({ isActive }) =>
                  `text-base font-medium ${isActive ? "text-forest" : "text-navy"}`
                }
                end={l.to === "/"}
              >
                {l.label}
              </NavLink>
            ))}
            <Link to="/partner" className="btn-primary rounded-full px-5 py-2 text-sm font-semibold text-center" data-testid="mobile-nav-cta">
              Partner with us
            </Link>
          </nav>
        </div>
      )}
    </header>
  );
}
